import { AppState } from 'store/root.reducer'

export const selectDataGatewayState = (state: AppState) => state?.dataGateway

export const selectLoadingDataGatewayStatus = (state: AppState) => selectDataGatewayState(state)?.loadingDataGatewayStatus
